import { logisticsAsset, logisticsSafety, manufacturingSteel } from "@pages/Enterprise/Solution/components/Banner/BannerImages";
import productImg from "../main/product/productImg";
import productPurchase from "../main/product/productPurchase";

export default {
  desc: '빅데이터가 무엇인지, 기업 디지털 전환에서 빅데이터의 활용 사례를 알아보세요. 빅데이터가 비즈니스 효율성을 최적화하는 방법을 탐구합시다!',
  keywords: '스마트 카메라, Smart Camera, 감시 카메라, 기업 솔루션',
  ogSite: '스마트 카메라 (Smart Camera)란 무엇일까요? 생활 속의 장점과 활용법',
  title: '스마트 카메라 (Smart Camera)란 무엇일까요? 생활 속의 장점과 활용법',
  ogUrl: 'https://orbro.io/blog/smart-camera',
  ogImg: 'https://lh3.googleusercontent.com/fife/ALs6j_G7vrDy7ESkuYISDayRbaaJNgxcfi3wUNj7XficqWdAMQN110CF1d-kZgHUGKhQ-5huNUN47KYJK3c_E2nQLEEHB9H4peNpHKi689CeskT9cc4Q8MKryy6QFARq7tRAsLOe6IQ4_fhCJ8uBn9Ugckn-nSB5p5MO6yfidlz7tVBkauBGJ8yyjN5k7NQFvGUxqxcBC_Z6Ed6DAnz6jQ0ckO1eidQak_B2Eg3bdvjCdWFV5o5itNM_UVBmJs_g3El10El99m2iv3kfi0L1hrRW6rZ1xR9LYn6v9Ha2EyAdNxOdqh3KLtA58xLD1M9kKMxdBCi9DbkgjwBAbNd3oz311GXnBAUhZQs1WqL-2p9yMUTDVwkMVcTT3F6IgVGPsDAiYuJ_B3kKfHI8IH_Bdug6LMhsZNOpduhsIShjiW9lBvVoDfeTvOZog6UK44-TwfPJT7lVoUIjubKX-zclnv239sBfOlENS9ME-AkJJ-6EmPxEJml7Wtmj-VX2VDQLm--FWXdlXToBIcIqj7ayWInW83KpahwIazl6aphk2FbkDZrnGt7dT2j1TLi5eW4lRnLmoafEqrVJF2zYeRCc2g3rxcyEZhxNw4uMVygVPTHOo82fcJA5U3NxlaMNHSIncgE3In-ppd6VopinNJzrERgH9DYv2yonwmQWn6GkDNX9mFqtTXJ-KomugsW5qsRNo4sdGRfFLeMNb0yjhrNvhqHdwpIUdd_Sbr8FUR2DrPbfBjpFZEfwyaKMZZ41n-yLApwj4kIO84ntbQX8FqJRiD-4ERqGUcCsRvS3xfDCqJAZDXo8RizTXmANbZy7ehot7eSwQpSaedM7ql0i6E6cAgExsyoX-jqVcuECKYxo_5cs4daGAPXJ17Xv4xsqFlddoRf60kgCaG1UMmHO77UYYyc1yMY4EdtR9O7p6Ox2NRev0oaamfNQemMg_PGQsJM-tIMR3ld2smpmytldlNErju28EN-tSKvY5fClA6YOrC_DUuJIiHbnC4aQ1SbopS6hSwtbYuRkGyc-_EXIuS8AdrwT4svQrCACrbdns8en6SXIX2pvyEowXbvMJ4wWk43wAzG6mQHQAea9oVSPobAqC1ApueEGItfW-8m-l65lOpdXJvMPj_h1AcJRogZU3uD_PZh2oNACnWHLyeBsvMh80mxVwPup8JQOORkTutxVgd8TcYFjHlswRRoabimG0ij8hmprwQCylbz14MBsTBesDbr382XqKah1CfHs7gFZMrTQvQE_HGtZP6UbjtVAW_L9ySevvT2pBTFpbwi3G0PRdfkwL-hEVcnPRhTm9IiVFr7R9aSWDQpdXQCsAbWCnfOtLh2QQOWAyG0iWlHZ6M4RQNWVgmcqCBG5_Tbeb_HnFxvy1NuAkljym5zowoxaHUwK8Ee--9xBYHXD1m3jw_-UcI2fsMFOf8fP2jxqfVQlVT4vb1XMRdYltBRFVygvXVfjBeFwXXl1xOfauK_E6Zz5dDeez-F-eBdAjmSwrZcNiHHRY-idtnsMzfc0D_0VPwgUECWQOUR7JvJ6VWD1efjkgfobI7XA3BBlqr6IX2giHjmsVMiYXgyT_uyPUi8EFrowoOY25JL56xuyX1mQbmE73DmIs5sr8fO2_juqjtU0=w1418-h1412?auditContext=forDisplay',
  ogType: 'website',
  date: '2025-07-10',
  tag1: '#스마트카메라',
  tag2: '#SmartCamera',
  tag3: '#감시카메라',
  tag4: '#기업솔루션',
  text: [
    {
      head: '1. 스마트 카메라 (Smart Camera)란 무엇인가?',
      subHead: '',
      desc: '스마트 카메라 (Smart Camera)는 인공지능(AI)과 인터넷 연결 기능을 탑재한 첨단 감시 장치로, 영상 녹화는 물론 데이터 분석 및 사용자와의 실시간 상호작용이 가능합니다. 기존의 아날로그 카메라와 달리, 얼굴 인식, 움직임 감지, 즉시 알림 전송, 클라우드 저장 등 다양한 지능형 기능을 제공하며, IoT(사물인터넷) 기술의 발전과 함께 점점 더 많은 가정과 기업, 공공시설에 도입되고 있습니다.\n\n단순한 녹화 장비를 넘어, 스마트 카메라는 사용자의 안전과 편의를 종합적으로 제공하는 지능형 보안 솔루션으로 자리 잡고 있습니다. 그럼 이제 스마트 카메라가 제공하는 다양한 이점과 활용 방법을 함께 살펴보겠습니다.',
      dot: ''
    },
    {
      head: '2. 스마트 카메라 (Smart Camera)의 주요 장점',
      subHead: 'AI 기반 지능형 감시',
      desc: 'AI 기술을 기반으로 한 스마트 카메라는 사람과 사물 구분, 얼굴 인식, 이상 행동 감지가 가능해, 침입이나 파손 같은 위험 상황을 빠르게 인식하고 알림을 전송합니다.\n예를 들어, Hikvision 또는 Dahua 같은 브랜드의 카메라는 딥러닝 알고리즘을 활용하여 영상 분석 정확도를 획기적으로 높였습니다.',
      dot: ''
    },
    {
      head: '',
      subHead: '원격 접속 및 실시간 모니터링',
      desc: '스마트 카메라는 Wi-Fi 또는 4G/5G 연결을 통해 스마트폰, 태블릿, 노트북에서 언제 어디서나 실시간 영상을 확인하고 저장된 영상을 재생할 수 있습니다.\n출장 중이거나 외출했을 때도 집이나 사무실 상황을 손쉽게 점검할 수 있어 매우 편리합니다.',
      dot: ''
    },
    {
      head: '',
      subHead: '유연한 클라우드 저장',
      desc: '기존의 SD 카드 저장 방식 외에도 클라우드 저장 기능을 지원하여, 카메라가 훼손되거나 도난당해도 영상이 안전하게 보관됩니다.\nGoogle Nest, Arlo 등의 서비스는 고급 암호화 기술을 적용해 장기 저장 및 보안을 강화하고 있습니다.',
      dot: ''
    },
    {
      head: '',
      subHead: '스마트 홈과의 통합',
      desc: '스마트 카메라는 스마트 조명, 스마트 스피커, 스마트 도어록 등 스마트 홈 기기와 연동되어 자동화된 환경을 구축할 수 있습니다.\n예를 들어, 움직임이 감지되면 조명이 자동으로 켜지고, 경고 메시지가 스피커로 전송되는 식입니다.',
      dot: ''
    },
    {
      head: '',
      subHead: '설치 간편 & 비용 절감',
      desc: '대부분의 스마트 카메라는 배선이 필요 없는 구조로 간단하게 설치할 수 있어 전문 기술자가 없어도 누구나 셀프 설치가 가능합니다.\n또한, 인건비 없이 자동 감시가 가능해 기업 입장에서도 운영 비용 절감 효과가 큽니다.',
      dot: ''
    },
    {
      head: '3. 스마트 카메라 (Smart Camera)의 실제 활용 분야',
      subHead: '가정 보안',
      desc: '스마트 카메라는 아이나 반려동물을 돌보는 데 이상적인 ‘디지털 수호자’입니다. 움직임 감지 시 스마트폰으로 즉시 알림을 전송하며, Hanwha Vision 또는 TP-Link Tapo와 같은 제품은 마이크와 스피커가 내장되어 있어 양방향 음성 통화도 가능합니다.',
      dot: ''
    },
    {
      head: '',
      subHead: '기업 및 매장 관리',
      desc: '매장에서는 고객 동선 파악, 도난 방지, 직원 관리 등 다방면에서 활용되며, 물류센터에서는 화물 입출고 및 위치 확인 등에 사용됩니다.\n또한, 고객 방문 수나 체류 시간 등을 분석하여 마케팅 전략 수립에도 활용됩니다.',
      dot: ''
    },
    {
      head: '',
      subHead: '스마트 시티 & 교통 관리',
      desc: '스마트 시티 구축을 위해 도로와 공공장소에 스마트 카메라가 설치되어 교통 흐름 감시, 신호 위반 감지, 사고 조사 등에 활용됩니다.\n예를 들어, 하노이와 호치민시에서는 교통 법규 위반을 자동으로 감지하여 ‘비대면 과태료 부과 시스템’을 도입하고 있습니다.',
      dot: ''
    },
    {
      head: '',
      subHead: '의료 분야',
      desc: '스마트 카메라는 병원 또는 재택 간호 환경에서 환자 상태 모니터링에 활용됩니다.\n특히 고령자나 장기 요양 환자의 낙상 감지, 체온 측정 등으로 빠른 대응이 가능합니다.',
      dot: ''
    },
    {
      head: '',
      subHead: '교육과 온라인 학습',
      desc: '스마트 카메라는 온라인 강의 녹화, 시험 감시, 출결 확인 등의 목적으로도 사용됩니다.\n이는 교육의 투명성을 높이고 비대면 수업의 품질을 개선하는 데 기여합니다.',
      dot: ''
    },
    {
      head: '4. 스마트 카메라 (Smart Camera) 선택 시 고려할 점',
      subHead: '',
      desc: '• 해상도: 최소 Full HD(1080p) 이상, 넓은 공간에는 2K 또는 4K 모델을 추천합니다.\n\n• 화각 (시야 범위): 120도~360도까지 다양한 제품이 있으며, 설치 환경에 맞는 각도를 선택하는 것이 좋습니다.\n\n• AI 기능 지원 여부: 얼굴 인식, 움직임 감지, 음성 제어(Google Assistant, Alexa 등) 지원 여부 확인해야 합니다.\n\n• 저장 방식: SD 카드, 클라우드 저장 또는 둘 다 지원하는지 확인할 필요합니다\n\n• 방수·방진 등급: 실외 설치용은 IP65 이상 등급을 선택하여 날씨에 강한 제품을 선택하는 것이 좋습니다.',
      dot: ''
    },
    {
      head: '5. 스마트 카메라 (Smart Camera)의 미래',
      subHead: '',
      desc: 'AI와 5G 기술의 발전으로 스마트 카메라는 더욱 지능화되고 고도화될 전망입니다.\n\n엣지 컴퓨팅을 통해 영상 데이터를 카메라에서 직접 분석해 반응 속도를 높이고,\nAI 예측 분석 기능으로 위험을 사전에 감지하며,\n스마트홈, 스마트빌딩, 스마트시티와의 통합으로 일상 속 모든 공간이 연결되는 보안 환경이 조성될 것입니다.\n\n미래에는 카메라가 상황에 따라 스스로 각도를 조정하고, 사용자의 습관과 감정 상태까지 분석하여 더 맞춤형 보안을 제공할 수 있게 됩니다.',
      dot: ''
    },
    {
      head: '6. 마무리',
      subHead: '',
      desc: '스마트 카메라는 단순한 감시 장치를 넘어 현대인의 삶을 더 안전하고 효율적으로 만들어주는 핵심 기술입니다.\n가정 보안부터 기업 관리, 도시 인프라까지 다양한 분야에서 사용되며, 기술 발전과 함께 그 가능성은 더욱 확장되고 있습니다.\n\n지금 바로 스마트 카메라를 도입하여 여러분의 공간을 스마트하고 안전하게 만들어보세요.\n설치 가이드나 제품 추천이 필요하다면, ORBRO와 함께 스마트 보안 솔루션의 세계를 탐험 해보세요!',
      dot: ''
    }
  ],

  link: {
    page: 'rtls',
    numb: '1',
    product: [
      {
        text: productPurchase.purchase.ble.bleStarterKit.title,
        title: productPurchase.purchase.ble.bleStarterKit.title,
        serial: productPurchase.purchase.ble.bleStarterKit.serial,
        desc: 'UWB 단말기를 작업자 또는 장비에 부착하여, 실시간으로 위치 추적을 돕는 제품입니다.',
        img: productImg.product.bleStarterKit.key1,
      },
      {},
    ],
    solution: [
      {
        img: logisticsAsset.thumb,
        data: 'logisticsAsset',
        link: '/enterprise/logistics/asset',
      },
      {
        img: logisticsSafety.thumb,
        data: 'logisticsSafety',
        link: '/enterprise/logistics/safety',
      },
      {
        img: manufacturingSteel.thumb,
        data: 'manufacturingSteel',
        link: '/enterprise/manufacturing/steel',
      },
    ],
  },
};
